function initEstimatorCursor() {
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

  const dot = document.getElementById("estimator-cursor-dot");
  const ring = document.getElementById("estimator-cursor-ring");
  if (!dot || !ring) return;

  let mx = 0;
  let my = 0;
  let rx = 0;
  let ry = 0;

  document.addEventListener("mousemove", (e) => {
    mx = e.clientX;
    my = e.clientY;
    dot.style.left = mx + "px";
    dot.style.top = my + "px";
  });

  function animateRing() {
    rx += (mx - rx) * 0.12;
    ry += (my - ry) * 0.12;
    ring.style.left = rx + "px";
    ring.style.top = ry + "px";
    requestAnimationFrame(animateRing);
  }

  animateRing();

  const hoverTargets = document.querySelectorAll(
    "a, button:not(.estimator-faq__trigger), [role='button'], input, textarea, select, label, .estimator-banner__card, .estimator-built__card-inner, .estimator-steps__rail article, .estimator-intro__cards li, .estimator-faq__item",
  );
  hoverTargets.forEach((el) => {
    el.addEventListener("mouseenter", () =>
      document.body.classList.add("cursor-hover"),
    );
    el.addEventListener("mouseleave", () =>
      document.body.classList.remove("cursor-hover"),
    );
  });
}

function initCardGlow() {
  const glowCards = document.querySelectorAll(".estimator-built__card-inner");
  glowCards.forEach((card) => {
    card.addEventListener("mousemove", (e) => {
      const rect = card.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      card.style.setProperty("--mx", x + "%");
      card.style.setProperty("--my", y + "%");
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    initEstimatorCursor();
    initCardGlow();
  });
} else {
  initEstimatorCursor();
  initCardGlow();
}
